import { Total } from 'graphql-api/baskets-api-interfaces';

export const totalToDiscount = (
  total: Total,
  useRrpForDiscount: boolean,
): { value: number; percentage: number } => {
  const requestedValue = useRrpForDiscount
    ? total.requested.rrp
    : total.requested.wsp;

  const discount =
    (useRrpForDiscount ? total.discounts?.rrp : total.discounts?.wsp) ?? 0;

  // discount can be on the product itself or we calculate it on FE
  const isDiscountFromProduct = total.requested.wsp === total.requested.net;
  const totalValue = isDiscountFromProduct
    ? discount + requestedValue
    : requestedValue;

  return {
    value: Math.abs(discount) * -1,
    percentage: requestedValue ? discount / totalValue : 0,
  };
};
